import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "focus-widget__header" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "My focus", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "focus-widget__actions"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" View focus ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Close focus ")
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 1,
  class: "status-indicator"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "outer-circle" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "inner-circle" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonMini = _resolveComponent("AppButtonMini")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_WidgetTimetracker = _resolveComponent("WidgetTimetracker")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_DailySyncOverlay = _resolveComponent("DailySyncOverlay")!

  return (_ctx.isDailySyncsEnabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["focus-widget", [
    _ctx.isSyncOlderThanDay && 'focus-widget--older',
    _ctx.minimized && 'focus-widget--minimized'
  ]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.minimized)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                (_ctx.dailySyncsForDayBeingViewed?.lastUpdatedAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " updated " + _toDisplayString(_ctx.timeDiffCalc(_ctx.dailySyncsForDayBeingViewed?.lastUpdatedAt as string, true)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.minimized)
            ? (_openBlock(), _createBlock(_component_AppButtonMini, {
                key: 1,
                theme: !_ctx.userHasSubmittedSync ? 'primary' : 'secondary',
                icon: _ctx.dailySyncOverlayActive ? 'close' : 'plays',
                onClick: _ctx.openSyncOverlay
              }, null, 8, ["theme", "icon", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.minimized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!_ctx.dailySyncOverlayActive)
                ? (_openBlock(), _createBlock(_component_AppButton, {
                    key: 0,
                    icon: "plays",
                    onClick: _ctx.openSyncOverlay,
                    theme: !_ctx.userHasSubmittedSync ? 'primary' : 'secondary'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick", "theme"]))
                : (_openBlock(), _createBlock(_component_AppButton, {
                    key: 1,
                    icon: "close-tiny",
                    onClick: _ctx.openSyncOverlay,
                    theme: !_ctx.userHasSubmittedSync ? 'primary' : 'secondary'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick", "theme"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTrackerRunning)
          ? _withDirectives((_openBlock(), _createBlock(_component_WidgetTimetracker, {
              key: 1,
              "onTimetracker:stop": _ctx.updateDaily
            }, null, 8, ["onTimetracker:stop"])), [
              [_vShow, !_ctx.minimized]
            ])
          : _createCommentVNode("", true),
        (!_ctx.minimized)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailySyncsForDayBeingViewed?.tasks, (task) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: task.id,
                  class: _normalizeClass({'completed': task.completed, 'tracking': task.id === _ctx.activeTrackedTask?.id })
                }, [
                  (task.completed)
                    ? (_openBlock(), _createBlock(_component_AppIcon, {
                        key: 0,
                        name: "check",
                        size: 7
                      }))
                    : _createCommentVNode("", true),
                  (task.id === _ctx.activeTrackedTask?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    innerHTML: task.text
                  }, null, 8, _hoisted_13)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DailySyncOverlay, {
          navMinimized: _ctx.minimized,
          preventClose: true
        }, null, 8, ["navMinimized"])
      ], 2))
    : _createCommentVNode("", true)
}